import * as React from "react";
import { action, observable } from "mobx";
import { inject, observer } from "mobx-react";
import { Dropdown, FormControl, InputGroup } from "react-bootstrap";
import { ColorResult, TwitterPicker } from "react-color";
import { IFilter } from "../../stores/filterStore";
import SymbolSelect from "../symbolselect/SymbolSelect";
import { AppProps } from "../../stores/storeContract";
import "./FilterItemModal.scss";
import Modal, {Modals} from 'react-mobx-modal';
import toastNotificationHelper from "../../helpers/toastNotificationHelper";

interface AppPropsFilterItem extends AppProps {  
  filter?: IFilter,
  filterIndex?: number;
  isOpen?: boolean
}

@inject("filterStore", "commonStore", "formatStore", "notificationStore", "settingsStore")
@observer
export default class FilterItemModal extends React.Component<AppPropsFilterItem> {

    @observable colorVisible: boolean = false;

    private colors: string[] = [
		'#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00',
		'#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080',
		'#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5',
		'#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500',
		'#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294',
		'#AB149E'
	];

    intervalChange(interval: number): void {
		if (this.props.filter.intervals.includes(interval)) {
			this.props.filter.intervals = this.props.filter.intervals.filter(i => i != interval);
		}
		else {
			this.props.filter.intervals.push(interval);
		}
    }

    @action.bound directionChange(choice: string): void {
		var direction = parseInt(choice);
		this.props.filter.priceChangeDirection = direction;
    }

    @action.bound changeChange(e:any): void {
      	this.props.filter.priceChangePercentage = parseInt(e.target.value);
    }

	@action.bound volumeChange(e:any): void {
		this.props.filter.volume = parseInt(e.target.value);
  }

    @action.bound soundChange(choice: string): void {
		var soundIndex = parseInt(choice);
		this.props.filter.soundIndex = soundIndex;

		if (soundIndex > 0) {
			this.props.notificationStore.playSound(soundIndex);
		}      
    }

    @action.bound colorChange(color: ColorResult): void {
		this.props.filter.color = color.hex;
		this.colorVisible = false;
    }

	@action.bound validateAndSaveFilter(): void {

		var filter = this.props.filter;
		
		if (filter.symbols == null || filter.symbols.length == 0){
			toastNotificationHelper.notifyError('No symbol selected');
			return;
		}

		if (filter.intervals == null || filter.intervals.length == 0){
			toastNotificationHelper.notifyError('No interval selected');
			return;
		}

		if (filter.priceChangeDirection == 0 && filter.priceChangePercentage < 3){
			toastNotificationHelper.notifyError('Invalid price change percentage');
			return;
		}

		if (filter.priceChangeDirection == 1 && filter.priceChangePercentage > -3){
			toastNotificationHelper.notifyError('Invalid price change percentage');
			return;
		}			

		this.props.filterStore.saveFilter(filter);
	}
  
    render() {

		const { filter, filterIndex } = this.props;
		const { removeFilter, cancelFilter } = this.props.filterStore;
		const { telegramEnabled, apiEnabled, defaultQuote } = this.props.settingsStore;

		var symbolSelectProps = {
			symbolSelect: filter,
			commonStore: this.props.commonStore,
			excludedSymbols: this.props.settingsStore.excludedSymbols
		}

		return (      		
			<Modals className="modals filter-item-modal">
				<Modal delay={300} className="root">
					<div className="filter-item-modal-inner">		
						<div className="row">	
							<div className="col-md-12">			
								<span className="filter-item-label"> Filter #{filterIndex}</span>
								<button className="btn close-button" onClick={cancelFilter}>
									<i className="fas fa-times-circle"></i>
								</button>
							</div>	
						</div>	
						<div className="row">
							<div className="col-md-4">
								{/* SYMBOLS */}
								<div className="filter-item-sublabel">Trading pairs</div>
								<div className="row">
									<div className="col-md-12">
										<SymbolSelect {...symbolSelectProps} />
									</div>
								</div>
							</div>
							<div className="col-md-4">

								{/* SYMBOL OPTIONS */}
								<div className="filter-item-sublabel">Trading pairs options</div>
								<div className="row">
									<div className="col-md-12">
										<div>
											<input type="checkbox" checked={filter.symbolsAutoSelect} onChange={() => filter.symbolsAutoSelect = !filter.symbolsAutoSelect} />
											Add newly listed pairs into filter
										</div>
									</div>
								</div>

								{/* INTERVALS */}
								<div className="filter-item-sublabel">Intervals</div>
								<div className="row">
									<div className="col-md-6">
										<div><input type="checkbox" checked={filter.intervals.includes(1)} onChange={() => this.intervalChange(1)} />1 minute</div>
										<div><input type="checkbox" checked={filter.intervals.includes(2)} onChange={() => this.intervalChange(2)} />5 minutes</div>
										<div><input type="checkbox" checked={filter.intervals.includes(3)} onChange={() => this.intervalChange(3)} />15 minutes</div>																				
									</div>
									<div className="col-md-6">
										<div><input type="checkbox" checked={filter.intervals.includes(4)} onChange={() => this.intervalChange(4)} />1 hour</div>
										<div><input type="checkbox" checked={filter.intervals.includes(5)} onChange={() => this.intervalChange(5)} />4 hours</div>
										<div><input type="checkbox" checked={filter.intervals.includes(6)} onChange={() => this.intervalChange(6)} />24 hours</div>
									</div>
								</div>

								{/* DIRECTION & CHANGE % */}
								<div className="filter-item-sublabel">Price Change Percentage</div>
								<div className="row no-gutters">
									<div className="col-md-10 no-padding">									
										<div><input type="radio" checked={filter.priceChangeDirection == 0} onChange={() => filter.priceChangeDirection = 0} />More than</div>
										<div><input type="radio" checked={filter.priceChangeDirection == 1} onChange={() => filter.priceChangeDirection = 1} />Less than</div>
									</div>
									<div className="col-md-10 no-padding">
									{/* <div><input type="number" /></div> */}
									<br/>
									<InputGroup className="mb-3 almost-full-width">                   
										<FormControl aria-label="Change"
													 type="number" 
													 pattern="[0-9]" 
													 min={filter.priceChangeDirection == 0 ? 3 : -100 } 
													 max={filter.priceChangeDirection == 0 ? 100 : -3}
													 value={filter.priceChangePercentage} 
													 onChange={this.changeChange} />
										<InputGroup.Append>
											<InputGroup.Text>%</InputGroup.Text>
										</InputGroup.Append>
									</InputGroup>
									</div>
								</div>

								{/* VOLUME */}
								<div className="filter-item-sublabel">Volume</div>
								<div className="row no-gutters">
									<div className="col-md-10 no-padding">									
										<div><input type="radio" checked={filter.volumeType == 0} onChange={() => filter.volumeType = 0} />Ignore</div>
										<div><input type="radio" checked={filter.volumeType == 1} onChange={() => filter.volumeType = 1} />More than per Interval</div>
										<div><input type="radio" checked={filter.volumeType == 2} onChange={() => filter.volumeType = 2} />More than per 24h</div>
									</div>
									<div className="col-md-10 no-padding">
									{/* <div><input type="number" /></div> */}
									<br/>
									<InputGroup className="mb-3 almost-full-width">                   
										<FormControl aria-label="Change" 
													 type="number" 
													 pattern="[0-9]" 
													 disabled={filter.volumeType == 0}
													 min={ 1 } 
													 value={filter.volume} 
													 onChange={this.volumeChange} />
										<InputGroup.Append>
											<InputGroup.Text>{defaultQuote}</InputGroup.Text>
										</InputGroup.Append>
									</InputGroup>
									</div>
								</div>
							</div>

							<div className="col-md-4">

								{/* SOUNDS */}
								<div className="filter-item-sublabel">Sound alerts</div>
								<div className="row no-gutters">
									<div className="col-md-12 no-padding">
									<Dropdown onSelect={this.soundChange} className="field-width">
										<Dropdown.Toggle variant="outline-dark" id="direction" className="full-width modal-btn">
											{filter.soundIndex == 0 ? 'No sound' : 'Sound ' + filter.soundIndex}
										</Dropdown.Toggle>
										<Dropdown.Menu>
											<Dropdown.Item eventKey="0">No sound</Dropdown.Item>
											<Dropdown.Item eventKey="1">Sound 1</Dropdown.Item>
											<Dropdown.Item eventKey="2">Sound 2</Dropdown.Item>
											<Dropdown.Item eventKey="3">Sound 3</Dropdown.Item>
											<Dropdown.Item eventKey="4">Sound 4</Dropdown.Item>
											<Dropdown.Item eventKey="5">Sound 5</Dropdown.Item>
											<Dropdown.Item eventKey="6">Sound 6</Dropdown.Item>
											<Dropdown.Item eventKey="7">Sound 7</Dropdown.Item>
											<Dropdown.Item eventKey="8">Sound 8</Dropdown.Item>
											<Dropdown.Item eventKey="9">Sound 9</Dropdown.Item>
											<Dropdown.Item eventKey="10">Sound 10</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>
									</div>
								</div>

								{/* COLOR */}
								<div className="filter-item-sublabel">Color</div>
								<div className="row no-gutters">
									<div className="col-md-12 no-padding">
									<button className="btn btn-outline-dark header-btn field-width modal-btn" onClick={() => this.colorVisible = !this.colorVisible}>
										Select
										<i className="fas fa-square color-icon" style={{color: filter.color}}></i>
									</button>
									<TwitterPicker className={this.colorVisible ? '' : 'hidden' } colors={ this.colors } triangle="hide" onChange={ this.colorChange } />
									</div>
								</div>

								{/* NOTIFICATIONS */}
								<div className="filter-item-sublabel">Notifications</div>
								<div className="row">
									<div className="col-md-12">
									<div>
										<input type="checkbox" 
											checked={filter.browserNotifications} 
											onChange={() => filter.browserNotifications = !filter.browserNotifications} />Browser
									</div>
									</div>
									<div className="col-md-12">
									<div className={apiEnabled ? '' : 'hidden'}>
										<input type="checkbox"                           
											checked={filter.apiNotifications} 
											onChange={() => filter.apiNotifications = !filter.apiNotifications} />API
									</div>
									</div>
									<div className="col-md-12">
									<div className={telegramEnabled ? '' : 'hidden'}>
										<input type="checkbox"
											checked={filter.telegramNotifications} 
											onChange={() => filter.telegramNotifications = !filter.telegramNotifications} />Telegram
									</div>
									</div>
								</div>
							</div>
						</div>
					
						<div className="row">
							<div className="col-md-12">
								{/* BUTTONS */}
								<div className="filter-item-sublabel"></div>
								<div className="row no-gutters">
									<div className="col-md-12 no-padding">
										<button className="btn btn-outline-danger header-btn float-right btn-spacing" onClick={() => removeFilter(filter.id)}>
											<i className="fas fa-trash"></i> Delete
										</button>
										<button className="btn btn-outline-success header-btn float-right btn-spacing" onClick={this.validateAndSaveFilter}>
											<i className="fas fa-save"></i> Save
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</Modal>
			</Modals>					
    	);
  	}
}